import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { ClipLoader } from "react-spinners";
import { useNavigate } from 'react-router-dom';

function AddCars() {
  const [carCategory, setCarCategory] = useState('');
  const [passengerCount, setPassengerCount] = useState(0);
  const [remark, setRemark] = useState('');
  const [rate, setRate] = useState('');
  const [carImage, setCarImage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [nextId, setNextId] = useState(null);

  const navigate = useNavigate();


  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); // Start loading state

    const formData = new FormData();
    formData.append('carID', nextId);
    formData.append('carCategory', carCategory);
    formData.append('passengerCount', passengerCount);
    formData.append('remark', remark);
    formData.append('rate', rate);
    if (carImage) {
      formData.append('carImage', carImage);
    }

    try {
      const response = await axios.post('https://genzserver.mylksystems.com/Cars/createCar', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      setLoading(false); // Stop loading state
      // console.log(response.data);
      setCarCategory('');
      setPassengerCount(0);
      setRemark('');
      setRate('');
      setCarImage(null);

      navigate('/ManageCars'); // Redirect to Manage Cars page after successful submission
    } catch (error) {
      console.error('Error submitting car:', error);
      alert('Submission failed. Check console for details.');
      setLoading(false); // Stop loading state in case of error
    }
  };

  return (
    <div
      style={{
        padding: '40px 20px',
        fontFamily: 'Segoe UI, sans-serif',
        backgroundColor: '#f8f9fa',
        minHeight: '100vh',
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      <div
        style={{
          width: '100%',
          maxWidth: '800px',
          backgroundColor: 'white',
          padding: '40px',
          borderRadius: '12px',
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
        }}
      >
        <form onSubmit={handleFormSubmit}>
          <h2
            style={{
              fontSize: '28px',
              marginBottom: '20px',
              color: '#333',
              textAlign: 'center',
            }}
          >
            Add a New Car
          </h2>

          {/* Car Category */}
          <div style={{ marginBottom: '30px' }}>
            <label
              style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold', fontSize: '16px' }}
            >
              Car Category:
            </label>
            <input
              type="text"
              value={carCategory}
              onChange={(e) => setCarCategory(e.target.value)}
              placeholder="Enter car category"
              style={{
                width: '100%',
                padding: '12px',
                fontSize: '15px',
                borderRadius: '6px',
                border: '1px solid #ccc',
                fontFamily: 'inherit',
              }}
              required
            />
          </div>

          {/* Passenger Count */}
          <div style={{ marginBottom: '30px' }}>
            <label
              style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold', fontSize: '16px' }}
            >
              Passenger Count:
            </label>
            <input
              type="number"
              value={passengerCount}
              onChange={(e) => setPassengerCount(parseInt(e.target.value) || 0)}
              placeholder="Enter the number of passengers"
              style={{
                width: '100%',
                padding: '12px',
                fontSize: '15px',
                borderRadius: '6px',
                border: '1px solid #ccc',
                fontFamily: 'inherit',
              }}
              required
            />
          </div>

          {/* Remark */}
          <div style={{ marginBottom: '30px' }}>
            <label
              style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold', fontSize: '16px' }}
            >
              Remark:
            </label>
            <textarea
              value={remark}
              onChange={(e) => setRemark(e.target.value)}
              rows={3}
              placeholder="Enter remarks about the car"
              style={{
                width: '100%',
                padding: '12px',
                fontSize: '15px',
                borderRadius: '6px',
                border: '1px solid #ccc',
                resize: 'vertical',
                fontFamily: 'inherit',
              }}
              required
            ></textarea>
          </div>

          {/* Rate */}
          <div style={{ marginBottom: '30px' }}>
            <label
              style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold', fontSize: '16px' }}
            >
              Rate:
            </label>
            <input
              type="text"
              value={rate}
              onChange={(e) => setRate(e.target.value)}
              placeholder="Enter rental rate"
              style={{
                width: '100%',
                padding: '12px',
                fontSize: '15px',
                borderRadius: '6px',
                border: '1px solid #ccc',
                fontFamily: 'inherit',
              }}
              required
            />
          </div>

          {/* Car Image */}
          <div style={{ marginBottom: '30px' }}>
            <label
              style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}
            >
              Car Image:
            </label>
            <input
              type="file"
              accept="image/*"
              onChange={(e) => setCarImage(e.target.files[0])}
              required
              style={{
                padding: '6px',
                borderRadius: '4px',
                border: '1px solid #ccc',
                width: '100%',
              }}
            />
          </div>

          {/* Submit Button */}
          <div style={{ textAlign: 'center' }}>
            <button
              type="submit"
              style={{
                padding: '12px 30px',
                fontSize: '18px',
                backgroundColor: '#28a745',
                color: 'white',
                border: 'none',
                borderRadius: '6px',
                cursor: 'pointer',
                transition: 'background-color 0.3s ease',
              }}
              onMouseOver={(e) => (e.target.style.backgroundColor = '#218838')}
              onMouseOut={(e) => (e.target.style.backgroundColor = '#28a745')}
            >
              {loading ? (
                <ClipLoader color="#ffffff" size={20} />
              ) : (
                'Submit Car'
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddCars;
